import React, { Component } from 'react';
import { doReviewsubmit, popModal, UpdateState, getState, getSession, AlertMessage, AlertMessageOut, clearSession } from "./function";
import ReactPaginate from 'react-paginate';
import { limit_per_page, name, ApiEndpoint, platform, currency } from "../Constant";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { DateTime } from "../Components/function";
import FileUnsupported from "../Assets/FileUnsupported.png";
import * as axios from 'axios';
import $ from "jquery";
import Button from './button';
import { Input } from './input';

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = 'visitor') => {
// Get the visitor identifier when you need it.
const fp = await fpPromise;
const result = await fp.get();

// This is the visitor identifier:
if(type === 'visitor'){
 return result.visitorId;
}
else{
  //return result.visitorId;
}
}


class DataTable extends Component{

    constructor(props){
      super(props);
      
      this.state = {
        page: 1,
        total_page: 1,
        total_result: 0,
        offset: '-1',
        offset_set: 0,
        limit: limit_per_page,
        page_target: '0',
        data: [],
        message: '',
        loading: '',
        retry_times: 0,
      }

      this.clearPagingData = this.clearPagingData.bind(this);
      this.updatePageTarget = this.updatePageTarget.bind(this);
      this.updatePageRegionTarget = this.updatePageRegionTarget.bind(this);
      }
  
      componentDidMount(){
       var that = this;
       this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));
      
      }
  
      componentDidUpdate(prevProps) {
       //this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));
      }
     
      AlertNoTableData = (len) => {
        return <tr><td colspan={len}><div className='p15 center block'>No Table Data - No Result found!</div></td></tr>;
      }
     
     clearPagingData = () => {
        UpdateState(this, 'page', 1);
        UpdateState(this, 'total_page', 1);
        UpdateState(this, 'total_result', 0);
        UpdateState(this, 'offset', '-1');
        UpdateState(this, 'offset_set', 0);
     }

     updatePageTarget(target){
       UpdateState(this, 'page_target', target);
     }

     updatePageRegionTarget(target){
       UpdateState(this, 'specific_region', target);
     }

      handlePageClick = (data) => {

        let selected = data.selected;
        let offset = Math.ceil((selected) * limit_per_page);
         UpdateState(this, 'offset', offset == 0 ? '-1' : offset);
         UpdateState(this, 'offset_set', offset);
         UpdateState(this, 'page', (selected + 1));
         let $specific = getState(this, 'page_target') == '1' ? '1' : ''; 
         if($specific != ""){
        this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), $specific);
        }
        else{
        this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), '');
        }
        };
      
      loadDataFromServer = async (cmd, offset, limit, specific = "") => {
        
        UpdateState(this, 'loading', '1');

        let DeviceSid = await FingerPrint();

        let header = {
            headers : {
                'Accept': 'application/json',
                'Content-Type': "application/x-www-form-urlencoded",
                'Authorization': "Bearer " + getSession('token') + ", Session " + DeviceSid + ", Platform "+ platform,
                'My-Custom-Header': name,
                'User-Agent': name+ " Bot",
               }
         };

         let datas = new URLSearchParams({
            command: 'fetch',
            cmd: this.props.cmd,
            user_id: getSession('userID'),
            limit: getState(this, 'limit'),
            offset: getState(this, 'offset'),
            page: getState(this, 'page'),
            specific: specific?.length ? specific : ''
        }).toString();
         
           axios.get(ApiEndpoint+"/fetchResult?"+datas, header)
           .then(response => {
           
            UpdateState(this, 'loading', '0');
           
            //alert(JSON.stringify(response.data.data));
            if(response.data.retry == true){
             let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
              setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.loadDataFromServer(cmd, offset, limit);
              }, 4000);
             }
             }
           }
      
          if(response.data.error == false && response.data.error != true){
          
          UpdateState(this, 'data', response.data.data != "" ? response.data.data : []);
          UpdateState(this, 'total_page', response.data.total_page);
          UpdateState(this, 'total_result', response.data.total_result);
          UpdateState(this, 'message', '');
          UpdateState(this, 'loading', '0');

          //alert(JSON.stringify(getState(this, 'data')));
            
            $(function() {

            $('.disabled').each(function() {
            //$(this).prop('title', "Disabled and Unavailable for Click Option");
            });
            
            });
    

          }
          else if(response.data.error != false){
            AlertMessage(this, response.data.error, 'error');
           UpdateState(this, 'loading', '0');
            if(response.data.logout == true && response.data.token == false){
              setTimeout(function(){
              clearSession();
              window.location.href = "/login";
              }, 4000);
              }
          }
          else{
             UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
          }
        }).catch(err => {
           UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
            this.loadDataFromServer(cmd, offset, limit);
        });
      }
  
withdrawalEmailAddress(){
  
  if(getState(this, 'data')?.wallet?.balance > 0){
  if(getState(this, 'data')?.wallet?.paypal_email != 'null' && getState(this, 'data')?.wallet?.paypal_email != '' && getState(this, 'data')?.wallet?.paypal_email != null){
 return(
  <>
  <div><div className="info">We have received your PayPal payout email <b>{getState(this, 'data')?.wallet?.paypal_email}</b> thank you!</div></div>
  </>
 );
  }
  else{
    return(
    <>
    <div>
  <div className="card-lt-wraps">
    <div className="card-lt">
      <div className="card-form-lt">
        <div className="title-lt">Submit your PayPal Email</div>
        <div>
      <div>Please provide your PayPal email address for your withdrawal</div>
      <Input 
      wrapperClass="form-group-lt"
      inputType="email"
      inputClass="input-lt"
      inputState="email"
      inputPlaceholder="PayPal Email Address"
      inputMaxLength="255"
      self={this.props?.self} />
      <Button 
       wrapperClass="form-group-lt" 
       buttonClass="button-lt" 
       buttonText="SUBMIT"
       buttonAction="add_paypal_email"
       self={this.props?.self} />

   </div></div></div></div></div>
</>
  );
  }
}
}

  render() {
    return ( 
        <>
    <div className="responsive-tables">

  {getState(this, 'loading') == '1' ?
   (<div className="table-loader">
  <div className="overlay">
    <div className="overlay__inner">
        <div className="overlay__content"><span className="spinner"></span></div>
    </div>
</div>
</div>) : ''}

    {AlertMessageOut(this)}


<div className="h1s" style={{fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '10px', }}>Balance: ${getState(this, 'data')?.wallet?.balance}</div>
<div>
  {this.withdrawalEmailAddress()}
</div>
<div className="grey-center hidden">
<h5>Wallet Address: {getState(this, 'data')?.wallet?.address}</h5>
</div>

    <div className="card-lt-wraps">
    <div className="card-lts">

 <div className="tab mtb10">
 <div className="tab-tab tab-label">
     <span className="fa fa-filter"></span>
     </div>
     <div className="tab-link tab-tab active"
     onClick={(event) => {this.updatePageTarget('0'); this.updatePageRegionTarget(''); this.clearPagingData(); this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));}}>
     <i className="fa fa-thumbs-up"></i> All
     </div>
     <div className="tab-link tab-tab" 
     onClick={(event) => {this.updatePageTarget('0'); this.updatePageRegionTarget(getSession('region')); this.clearPagingData(); this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), '1');}}>
     <i className="fa fa-download"></i> Credit
     </div>
     <div className="tab-link tab-tab" 
     onClick={(event) => {this.updatePageTarget('0'); this.updatePageRegionTarget('-1'); this.clearPagingData(); this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), '-1');}}>
     <i className="fa fa-upload"></i> Debit
     </div>
 </div>
</div>
</div>


<div className="responsive-table">
    <table>
        
 <thead><tr>
 <th>S/N</th>
     {this.props.th?.map((th, i) => {
      return <th className={this.props.thclassX[i]} key={i}>{th}</th>
     })}
 </tr>
 </thead>

 <tbody>
 {getState(this, 'data')?.tx?.length == 0 ? this.AlertNoTableData(this.props.th.length + 1) : ''}
 {getState(this, 'data')?.tx?.map((td, i) => {
        
   return(
     <tr key={i}>
     <td key={i}> {i+1} </td>
     <td className="nowrap">${td['amount']}</td>
     <td><span className={td['type_badge']}>{td['type']}</span></td>
     <td className="absorbing-column min-width-td">{td['summary']}</td> 
     <td>{td['txid']}</td>   
     <td className="nowrap">{td['added']}</td>  
    </tr>
    );
     })}

     </tbody>

    <tfoot><tr>
    <th>S/N</th>
     {this.props.th?.map((th, i) => {
      return <th className={this.props.thclassX[i]} key={i}>{th}</th>
     })}
 </tr>
 </tfoot>

</table>
</div>

<div className="card-lt">  

<div>Page: {getState(this, 'page')} of {getState(this, 'total_page')} ⟺ ☆ Result: {parseInt(getState(this, 'offset_set')) + parseInt(1)} - {Math.ceil(getState(this, 'page') * limit_per_page) >= getState(this, 'total_result') ? getState(this, 'total_result') : Math.ceil(getState(this, 'page') * limit_per_page)} of {getState(this, 'total_result')}</div>

<ReactPaginate
          previousLabel={'« Prev'}
          nextLabel={'Next »'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={getState(this, 'total_page')}
          marginPagesDisplayed={2}
          pageRangeDisplayed={4}
          onPageChange={this.handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
 </div>
</div>
</>
);
}
}

export default DataTable;